import { Popover, PopoverContent, PopoverTrigger } from '@/components/shadcn/popover'
import { useState } from 'react'

export function ComposedPopoverV2({
  children,
  trigger,
  className,
  open,
  setOpen,
}: {
  children: React.ReactNode
  trigger: React.ReactNode
  className?: string
  open?: boolean
  setOpen?: (open: boolean) => void
}) {
  const [internalOpen, setInternalOpen] = useState(false)
  const isControlled = typeof open === 'boolean' && typeof setOpen === 'function'
  const resolvedOpen = isControlled ? open : internalOpen
  const handleOpenChange = (nextOpen: boolean) => {
    // Always notify parent first if provided
    if (setOpen) setOpen(nextOpen)
    // Maintain internal state only when uncontrolled
    if (!isControlled) setInternalOpen(nextOpen)
  }
  return (
    <Popover open={resolvedOpen} onOpenChange={handleOpenChange}>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <PopoverContent className={className}>{children}</PopoverContent>
    </Popover>
  )
}
